import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";
import { IProduct } from "../models/productData.model";
import ResponseModel from "../models/response.model";
// Fetch all products
export const fetchAllProducts = async () => {
  try {
    const response = await axiosSetup.get("/product/getAllProduct");
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch products:", error);
    return toast.error("Failed to fetch products");
  }
};

export const createOrUpdateProductBOMApi = async (
  payload: any,
): Promise<ResponseModel> => {
  const response = await axiosSetup.post(
    "/product/create-or-update-product-bom",
    payload,
  );
  return response?.data;
};

export const createOrUpdateMaterialBOMApi = async (payload: any) => {
  try {
    const materialPayload = {
      materialBomId: payload.productBomId,
      materialId: payload.productId,
      components: payload.components,
    };

    const response = await axiosSetup.post(
      "/product/create-or-update-material-bom",
      materialPayload,
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to create/update Product BOM:", error);
    return toast.error("Failed to create/update Product BOM");
  }
};

export const getProductBOMByIdApi = async (bomId: string) => {
  try {
    const response = await axiosSetup.get(`/product/get-product-bom/${bomId}`);
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch Product BOM:", error);
    return toast.error("Failed to fetch Product BOM");
  }
};
export const getMaterialBOMByIdApi = async (bomId: string) => {
  try {
    const response = await axiosSetup.get(`/product/get-material-bom/${bomId}`);
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch Product BOM:", error);
    return toast.error("Failed to fetch Product BOM");
  }
};
// Add a new product
export const handleAddProduct = async (newProduct: any) => {
  try {
    const response = await axiosSetup.post("/product/addProduct", newProduct);
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to add product:", error);
    return toast.error("Failed to add product");
  }
};

// Delete a product
export const handleDeleteProduct = async (productId: string) => {
  try {
    await axiosSetup.delete("/product/deleteProduct", {
      data: { productId },
    });
    return productId;
  } catch (error) {
    toast.error("Failed to delete product");
    throw new Error("Failed to delete product");
  }
};

//update product
export const handleUpdateProduct = async (id: string, payload: any) => {
  try {
    const response = await axiosSetup.put(
      `/product/updateProduct/${id}`,
      payload,
    );

    return response.data.data;
  } catch (error) {
    toast.error("Failed to update product");
  }
};

export const getProductByIdApi = async (productIds: string[]) => {
  try {
    const response = await axiosSetup.post(`/product/getProductsByIds`, {
      productIds: productIds,
    });
    return response.data.data;
  } catch (error) {
    toast.error("Failed to fetch product");
  }
};

export const resendWarrantyDetailsApi = async (payload: {
  id: string;
  mobileNumber?: string;
}) => {
  try {
    const response = await axiosSetup.post(
      "/products/warranty/resend",
      payload,
    );
    return response.data.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to resend warranty");
    throw error;
  }
};

export const fetchProductsListApi = async (): Promise<IProduct[]> => {
  try {
    const res = await axiosSetup.get("/product/getProductsList");
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchProductsByWarehousPaginationeApi = async (
  warehouseId: string,
  page: number = 1,
  limit: number = 10,
  search: string = "",
  sortBy: string = "",
  sortOrder: string = "",
) => {
  try {
    const response = await axiosSetup.get("/product/warehouse", {
      params: { warehouseId, page, limit, search, sortBy, sortOrder },
    });
    return response.data.data;
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message || "Failed to load warehouse products",
    );
    throw error;
  }
};
export const getProductsStockForAdminViewPagination = async (
  page: number,
  limit: number,
  search: string = "",
) => {
  const response = await axiosSetup.get("/product/admin/stock", {
    params: { page, limit, search },
  });
  return response.data.data;
};

export const downloadProductStockReportForAdminApi = async ({
  format,
  search = "",
  date,
}: {
  format: "xlsx" | "csv";
  search?: string;
  date: string;
}) => {
  try {
    const res = await axiosSetup.get("/product/admin/stock/download", {
      params: { format, search, date },
      responseType: "blob",
    });
    return res.data;
  } catch (error) {
    throw new Error("Failed to generate and download store stock report.");
  }
};

export const getProductsCostByWarehouse = async () => {
  try {
    const res = await axiosSetup("/product/admin/product-cost");
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const addStockToWarehouseApi = async ({
  productId,
  warehouseId,
  quantity,
  productPrice,
  gst,
  transportPrice,
  handlingCost,
}: {
  productId: string;
  warehouseId: string;
  quantity: number;
  productPrice: number;
  gst: number;
  transportPrice: number;
  handlingCost: number;
}) => {
  const response = await axiosSetup.post(`/product/${productId}/add-stock`, {
    warehouseId,
    quantity,
    productPrice,
    gst,
    transportPrice,
    handlingCost,
  });
  return response.data.data;
};
